import { makeStyles } from '@fluentui/react-components';
import { Color } from 'libs/theme/src/lib/colors';

export const userActionStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    justifyContent: 'space-between',
    width: '26rem',
    borderRadius: '6px',
  },

  modalHeader: {
    display: 'flex',
    width: '25.9rem',
    padding: '0.75rem',
    borderTopRightRadius: '5px',
    borderTopLeftRadius: '5px',
    backgroundColor: Color.drawer_header_color,
    alignItems: 'center',
    fontSize: '1rem',
    fontWeight: 700,
    justifyContent: 'space-between',
  },

  modalBody: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '1.5rem',
    padding: '1.5rem',
  },

  modalBodyWithChildren: {
    display: 'flex',
    flexDirection: 'column',
    // alignItems: 'center',
    justifyContent: 'center',
    gap: '1.5rem',
    padding: '1.5rem',
  },

  modalFooter: {
    gap: '1rem',
    padding: '0.75rem',
    width: '25.8rem',
    backgroundColor: Color.drawer_header_color,
    justifyContent: 'center',
    boxShadow: 'inset 0px 1px 0px var(--gray-200)',
  },

  description: {
    textAlign: 'center',
    fontSize: '1rem',
  },
  loaderContainer: {
    padding: '40px',
  },
  marginBottomDiv: {
    marginBottom: '-40px !important',
  },
  overflowAuto: {
    overflow: 'auto',
  },
  group: {
    marginBottom: '1.5rem',
  },
});
